export const setPets = (pets) => {
  return {
    type: 'setPets',
    pets: pets
  }
}
